export const ConfirmPopupVariant = {
  DEFAULT: "default",
  DELETE: "delete",
  EMPTY: "empty",
} as const;

export type ConfirmPopupVariant = (typeof ConfirmPopupVariant)[keyof typeof ConfirmPopupVariant];

export const ConfirmPopupResult = {
  OK: "ok",
  CANCEL: "cancel",
  DONT_SEND: "dontSend",
} as const;
export type ConfirmPopupResult = (typeof ConfirmPopupResult)[keyof typeof ConfirmPopupResult];
